"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
}
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationHelper_1 = require("./ValidationHelper");
var dateUtils = __importStar(require("../../utils/DateUtils"));
function Before(value) {
    return function (target, propertyKey, parameterIndex) {
        var beforeValidator = function (fieldValue) {
            var valueDate = null;
            if (value instanceof Date) {
                valueDate = value;
            }
            else {
                valueDate = dateUtils.parseDate(value);
            }
            if (fieldValue.getTime !== undefined && fieldValue.getTime() >= valueDate.getTime()) {
                return "Value must be before " + value;
            }
            return null;
        };
        ValidationHelper_1.addValidationRule(target, parameterIndex, beforeValidator);
    };
}
exports.Before = Before;
